'use strict';

const jQuery = require('jquery');

const container = require('./../../core/container');

module.exports.show = function(text, callback) {
    let $div = jQuery('<div class="notification-alert"><span class="icon icon-times"></span></div>');
    let $toolbar = container.get('$toolbar');

    $div.prepend(text);

    if (typeof callback === 'function') {
        $div.on('click', callback);
    }

    $toolbar.append($div);
};

module.exports.hide = function() {
    jQuery('.notification-alert').remove();
};
